import createStore from "astrid-helpers/src/createStore";

export const [getLoadingRender, setLoadingRender, useLoadingRender, onLoadingRender] = createStore(false);
